export default __webpack_public_path__ + "static/media/red.dfe5b8b0.svg";